import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, IsString, ValidateNested, IsBoolean } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";

export class BSPTicket {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  ticketNumber!: string;
  @IsNumber()
  @Expose()
  grandTotal!: number;
  @IsString()
  @Expose()
  issueDate!: string;
  @IsString()
  @Expose()
  relatedTicketNumber!: string;
  @IsString()
  @Expose()
  comments!: string;
  @IsBoolean()
  @Expose()
  isMatched!: boolean;
}

export class BSPTicketResponse extends GenericTableResponse<BSPTicket> {
  @Expose()
  @IsArray()
  @Type(() => BSPTicket)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<BSPTicket>;
}
